module.exports = __webpack_public_path__ + "img/bg.14daaac4.png";